import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { Box } from '@mui/material';
import useGetEventLogTypesLocal from '@src/adapters/hooks/eventLog/useGetEventLogTypesLocal';

interface Props {
  selection(selectedGroup: string | null): void;
  selected: string | null;
}

function EventLogGroupAutoComplete({ selection, selected }: Props) {
  const [open, setOpen] = useState(false);
  const { getTypes } = useGetEventLogTypesLocal();
  const loading = open;

  const [availableGroups, setAvailableGroups] = useState<string[]>([]);

  useEffect(() => {
    const fetchGroups = async () => {
      const types = await getTypes();

      const groups = Array.from(new Set(types.map((t) => t.group))).sort(
        (a, b) => a.toLowerCase().localeCompare(b.toLowerCase())
      );

      setAvailableGroups(groups);
    };

    fetchGroups();
  }, [getTypes]);

  const onOpen = () => {
    setOpen(true);
  };

  return (
    <Box>
      <Autocomplete
        open={open}
        onOpen={onOpen}
        onClose={() => {
          setOpen(false);
        }}
        onChange={(option, value) => {
          selection(value);
        }}
        value={selected}
        isOptionEqualToValue={(option, value) => option === value}
        getOptionLabel={(option) => option}
        options={availableGroups}
        loading={loading}
        filterSelectedOptions={true}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Event Group"
            variant="standard"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    </Box>
  );
}
export default EventLogGroupAutoComplete;
